import {Step0, Step1, Step2, Step3, Step4_0, Step4_1, Step5, Step6, Step7} from './components';

import {StoryStepsProps} from './StorySteps.types';

/**
 * This component is used in the `ResultStory` route, and is responsible
 * for rendering the animated DOM content for the results story. It it meant
 * to be used alongside the StoryVideos component, which manages the underlying
 * video backgrounds that this content is meant to appear on top of.
 *
 * TODO: The step where a users's results are compared to others has been
 * temporarily disabled. When re-enabling this, the corresponding step
 * configuration in `ResultStory.util.ts` must also be updated.
 */
export const StorySteps = ({activeStep = 0, ...otherProps}: StoryStepsProps) => (
  <div aria-live="assertive">
    {[Step0, Step1, Step2, Step3, Step4_0, Step4_1, Step5, Step6, Step7].map((Step, i) => (
      <Step key={i} show={activeStep === i} {...otherProps} />
    ))}
  </div>
);
